<nav
  #nav
  class="sm:px-4 flex flex-col h-full w-full bg-primary-500 select-none relative"
  [@openClose]="isMobile() ? 'mobile' : isOpen() ? 'open' : 'closed'"
  (@openClose.done)="onOpenAnimationDone()"
  (click)="onNavClick()"
>
  @if (!isMobile()) {
    <img
      [src]="isDarkMode() ? 'assets/images/polygons_dark.svg' : 'assets/images/polygons_light.svg'"
      alt=""
      class="absolute -bottom-[190px] left-0 w-[676px] h-[507px] object-none"
    />
  }

  <div class="sm:contents absolute inset-0 flex flex-col">
    <div class="md:hidden flex py-6 px-[19px]">
      <a [routerLink]="[RouteSegments.Root]" class="mx-auto">
        <img src="assets/images/helix-light.svg" alt="logo" class="h-10" />
      </a>
    </div>
    @if (isOnlyTablet()) {
      <div class="flex gap-2 mb-2 py-4 px-[10px]">
        <div class="flex items-center h-10">
          <div
            class="flex justify-center items-center shrink-0 w-[36px] h-[36px] cursor-pointer rounded-full hover:bg-primary-600 dark:hover:bg-primary-400"
            (click)="toggle($event)"
          >
            <svg-icon [key]="isOpen() ? 'cancel-32' : 'hamburger-menu-32'" class="text-text-000 dark:text-text-700 pointer-events-none" />
          </div>
        </div>
        @if (isOpen()) {
          <a [routerLink]="[RouteSegments.Root]" class="mx-auto">
            <img src="assets/images/helix-light.svg" alt="logo" class="h-10" />
          </a>
        }
      </div>
    }
    <div class="flex flex-1 flex-col min-h-0 px-1 sm:px-0 sm:gap-y-2 gap-y-1.5 overflow-y-auto overflow-overlay">
      @if (isLoggedIn()) {
        <app-side-menu-item
          [isSideMenuOpen]="isOpen() && isFullyOpened()"
          *appIfPermission="[PermissionStoreModelEnum.VIEW_ICO_DASHBOARD]; else participantDashboardMenuItem"
          [routeSegments]="[RouteSegments.Root]"
          [isExactRoute]="true"
          iconKey="home-24"
          [label]="'side-menu.ico-dashboard' | translate"
          (navigationClick)="onNavigationClick($event)"
        />
        <ng-template #participantDashboardMenuItem>
          <app-side-menu-item
            [isSideMenuOpen]="isOpen() && isFullyOpened()"
            *appIfPermission="[PermissionStoreModelEnum.VIEW_PARTICIPANT_DASHBOARD]"
            [routeSegments]="[RouteSegments.Root]"
            [isExactRoute]="true"
            iconKey="home-24"
            [label]="'side-menu.participant-dashboard' | translate"
            (navigationClick)="onNavigationClick($event)"
          />
        </ng-template>
      }

      <app-side-menu-item
        [isSideMenuOpen]="isOpen() && isFullyOpened()"
        [routeSegments]="[RouteSegments.Root, RouteSegments.Public, RouteSegments.PlatformOverview]"
        iconKey="eleclink-overview-24"
        [label]="'side-menu.public.platform-overview' | translate"
        (navigationClick)="onNavigationClick($event)"
      />

      @if (isLoggedIn()) {
        @if (!isMobile()) {
          <app-side-menu-nested-item
            [isSideMenuOpen]="isOpen() && isFullyOpened()"
            *appIfPermission="[
              PermissionStoreModelEnum.VIEW_NTC_OVERVIEW,
              PermissionStoreModelEnum.MANAGE_NTC,
              PermissionStoreModelEnum.VIEW_ATC_OVERVIEW,
              PermissionStoreModelEnum.MANAGE_ATC,
              PermissionStoreModelEnum.VIEW_PLANNED_OUTAGES,
              PermissionStoreModelEnum.VIEW_UNPLANNED_OUTAGES,
              PermissionStoreModelEnum.VIEW_CAPACITY_OVERVIEW,
            ]"
            iconKey="capacity-manager-24"
            [label]="'side-menu.capacity-manager' | translate"
            [isMenuOpen]="isCapacityMenuOpen()"
            [routes]="[
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Capacity, RouteSegments.NtcOverview],
                label: 'side-menu.ntc-overview' | translate,
                permissions: [PermissionStoreModelEnum.VIEW_NTC_OVERVIEW],
              },
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Capacity, RouteSegments.NtcManagement],
                label: 'side-menu.ntc-management' | translate,
                permissions: [PermissionStoreModelEnum.MANAGE_NTC],
              },
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Capacity, RouteSegments.OutageManagement],
                label: 'side-menu.outage-management' | translate,
                permissions: [PermissionStoreModelEnum.VIEW_PLANNED_OUTAGES, PermissionStoreModelEnum.VIEW_UNPLANNED_OUTAGES],
              },
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Capacity, RouteSegments.AtcOverview],
                label: 'side-menu.atc-overview' | translate,
                permissions: [PermissionStoreModelEnum.VIEW_ATC_OVERVIEW],
              },
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Capacity, RouteSegments.AtcManagement],
                label: 'side-menu.atc-management' | translate,
                permissions: [PermissionStoreModelEnum.MANAGE_ATC],
              },
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Capacity, RouteSegments.CapacityOverview],
                label: 'side-menu.capacity-overview' | translate,
                permissions: [PermissionStoreModelEnum.VIEW_CAPACITY_OVERVIEW],
              },
            ]"
            (navigationClick)="onNavigationClick($event)"
          />
        } @else {
          <app-side-menu-item
            [isSideMenuOpen]="isOpen() && isFullyOpened()"
            *appIfPermission="[PermissionStoreModelEnum.VIEW_NTC_OVERVIEW]"
            [routeSegments]="[RouteSegments.Root, RouteSegments.Capacity, RouteSegments.NtcOverview]"
            [label]="'side-menu.ntc-overview' | translate"
            (navigationClick)="onNavigationClick($event)"
          />
          <app-side-menu-item
            [isSideMenuOpen]="isOpen() && isFullyOpened()"
            *appIfPermission="[PermissionStoreModelEnum.VIEW_ATC_OVERVIEW]"
            [routeSegments]="[RouteSegments.Root, RouteSegments.Capacity, RouteSegments.AtcOverview]"
            [label]="'side-menu.atc-overview' | translate"
            (navigationClick)="onNavigationClick($event)"
          />
        }
      }

      @if (isLoggedIn()) {
        <app-side-menu-item
          [isSideMenuOpen]="isOpen() && isFullyOpened()"
          *appIfPermission="[PermissionStoreModelEnum.VIEW_ANY_TRANSMISSION_RIGHTS, PermissionStoreModelEnum.VIEW_OWN_TRANSMISSION_RIGHTS]"
          [routeSegments]="[RouteSegments.Root, RouteSegments.TransmissionRights]"
          iconKey="transmission-rights-24"
          [label]="'side-menu.transmission-rights' | translate"
          (navigationClick)="onNavigationClick($event)"
        />
      }

      @if (isLoggedIn()) {
        @if (!isMobile()) {
          <app-side-menu-nested-item
            [isSideMenuOpen]="isOpen() && isFullyOpened()"
            *appIfPermission="[
              PermissionStoreModelEnum.VIEW_OWN_NOMINATIONS,
              PermissionStoreModelEnum.MANAGE_OWN_NOMINATIONS,
              PermissionStoreModelEnum.VIEW_ANY_NOMINATIONS,
              PermissionStoreModelEnum.MANAGE_ANY_NOMINATIONS,
              PermissionStoreModelEnum.VIEW_BPP,
              PermissionStoreModelEnum.VIEW_OWN_AGGREGATED_NOMINATIONS,
              PermissionStoreModelEnum.VIEW_ANY_AGGREGATED_NOMINATIONS,
              PermissionStoreModelEnum.VIEW_OWN_DEFAULT_NOMINATIONS,
            ]"
            iconKey="nomination-24"
            [label]="'side-menu.nominations' | translate"
            [isMenuOpen]="isNominationMenuOpen()"
            [routes]="[
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Nominations, RouteSegments.NominationsOverview],
                label: 'side-menu.nomination-overview' | translate,
                permissions: [
                  PermissionStoreModelEnum.VIEW_OWN_AGGREGATED_NOMINATIONS,
                  PermissionStoreModelEnum.VIEW_ANY_AGGREGATED_NOMINATIONS,
                ],
              },
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Nominations, RouteSegments.NominationsManagement],
                label: 'side-menu.nomination-management' | translate,
                permissions: [
                  PermissionStoreModelEnum.VIEW_OWN_NOMINATIONS,
                  PermissionStoreModelEnum.MANAGE_OWN_NOMINATIONS,
                  PermissionStoreModelEnum.VIEW_ANY_NOMINATIONS,
                  PermissionStoreModelEnum.MANAGE_ANY_NOMINATIONS,
                  PermissionStoreModelEnum.VIEW_BPP,
                ],
              },
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Nominations, RouteSegments.NominationGatesOverview],
                permissions: [PermissionStoreModelEnum.VIEW_NOMINATION_GATES_OVERVIEW],
                label: 'side-menu.nomination-gates-overview' | translate,
              },
              {
                routeSegments: [RouteSegments.Root, RouteSegments.Organisation, RouteSegments.OrganisationDefaultNomination],
                label: 'side-menu.default-nominations' | translate,
                permissions: [PermissionStoreModelEnum.VIEW_OWN_DEFAULT_NOMINATIONS],
                forcedHighlightState: SideMenuNestedItemHighlightViewModelEnum.NoHighlight,
                isShortcut: true,
              },
            ]"
            (navigationClick)="onNavigationClick($event)"
          />
        } @else {
          <app-side-menu-item
            [isSideMenuOpen]="isOpen() && isFullyOpened()"
            *appIfPermission="[
              PermissionStoreModelEnum.VIEW_OWN_AGGREGATED_NOMINATIONS,
              PermissionStoreModelEnum.VIEW_ANY_AGGREGATED_NOMINATIONS,
            ]"
            [routeSegments]="[RouteSegments.Root, RouteSegments.Nominations, RouteSegments.NominationsOverview]"
            [label]="'side-menu.nomination-overview' | translate"
            (navigationClick)="onNavigationClick($event)"
          />
          <app-side-menu-item
            [isSideMenuOpen]="isOpen() && isFullyOpened()"
            *appIfPermission="[PermissionStoreModelEnum.VIEW_NOMINATION_GATES_OVERVIEW]"
            [routeSegments]="[RouteSegments.Root, RouteSegments.Nominations, RouteSegments.NominationGatesOverview]"
            [label]="'side-menu.nomination-gates-overview' | translate"
            (navigationClick)="onNavigationClick($event)"
          />
        }
      }

      @if (isLoggedIn() && !isMobile()) {
        <app-side-menu-item
          [isSideMenuOpen]="isOpen() && isFullyOpened()"
          *appIfPermission="[
            PermissionStoreModelEnum.VIEW_OWN_TRANSMISSION_RIGHTS,
            PermissionStoreModelEnum.VIEW_ANY_TRANSMISSION_RIGHTS,
            PermissionStoreModelEnum.VIEW_OWN_AGGREGATED_NOMINATIONS,
            PermissionStoreModelEnum.VIEW_ANY_AGGREGATED_NOMINATIONS,
            PermissionStoreModelEnum.VIEW_OWN_NOMINATIONS,
            PermissionStoreModelEnum.VIEW_ANY_NOMINATIONS,
            PermissionStoreModelEnum.VIEW_NTC_OVERVIEW,
            PermissionStoreModelEnum.VIEW_UNPLANNED_OUTAGES,
            PermissionStoreModelEnum.VIEW_PLANNED_OUTAGES,
            PermissionStoreModelEnum.VIEW_CRISIS,
            PermissionStoreModelEnum.VIEW_BPP,
            PermissionStoreModelEnum.VIEW_ANY_ORGANISATIONS,
            PermissionStoreModelEnum.VIEW_OWN_USERS,
            PermissionStoreModelEnum.VIEW_ANY_USERS,
            PermissionStoreModelEnum.VIEW_OWN_AUDIT_LOGS,
            PermissionStoreModelEnum.VIEW_ANY_AUDIT_LOGS,
          ]"
          [routeSegments]="[RouteSegments.Root, RouteSegments.Reports]"
          iconKey="report-24"
          [label]="'side-menu.reports' | translate"
          (navigationClick)="onNavigationClick($event)"
        />
      }

      @if (hasCrisis()) {
        <a
          *appIfPermission="[PermissionStoreModelEnum.VIEW_CRISIS]"
          [routerLink]="[RouteSegments.Root, RouteSegments.CrisisManagement]"
          [routerLinkActiveOptions]="{ exact: false }"
          routerLinkActive=""
          #rla="routerLinkActive"
          class="sm:px-4 sm:py-4 md:px-3 sm:justify-start sm:border sm:border-primary-450 px-3.5 h-12 rounded text-x-small font-bold flex-shrink-0 flex items-center gap-x-1 hover:bg-primary-600 dark:hover:bg-primary-400 sm:dark:border-primary-700 text-text-000 dark:text-text-700"
          [class.bg-secondary-500]="rla.isActive"
          [class.pointer-events-none]="!isOpen() || !isFullyOpened()"
          (click)="onNavigationClick($event)"
        >
          <div class="sm:hidden w-6 h-6 relative">
            <div class="rounded-full w-2 h-2 bg-error-500 absolute -translate-x-1/3"></div>
            <svg-icon key="crisis-24" />
          </div>
          @if (isOpen() && isFullyOpened()) {
            <div class="sm:text-large">{{ 'side-menu.crisis-management' | translate }}</div>
            <div class="hidden sm:block ml-auto rounded-full w-3 h-3 bg-error-500"></div>
          }
        </a>
      } @else if (!isMobile()) {
        <ng-container *appIfPermission="[PermissionStoreModelEnum.VIEW_CRISIS]">
          <a
            *appIfPermission="[PermissionStoreModelEnum.VIEW_UNPLANNED_OUTAGES]"
            [routerLink]="[RouteSegments.Root, RouteSegments.Capacity, RouteSegments.OutageManagement, RouteSegments.UnplannedOutages]"
            class="sm:px-4 sm:py-4 md:px-3 sm:justify-start sm:border sm:border-primary-450 px-3.5 h-12 rounded text-x-small font-bold flex-shrink-0 flex items-center gap-x-1 hover:bg-primary-600 dark:hover:bg-primary-400 sm:dark:border-primary-700 text-text-000 dark:text-text-700"
            [class.pointer-events-none]="!isOpen || !isFullyOpened"
            (click)="onNavigationClick($event)"
          >
            <svg-icon key="crisis-24" />
            @if (isOpen()) {
              <span>{{ 'side-menu.crisis-management' | translate }}</span>
            }
          </a>
        </ng-container>
      }

      @if (isLoggedIn() && !isMobile()) {
        <app-side-menu-item
          [isSideMenuOpen]="isOpen() && isFullyOpened()"
          *appIfPermission="[PermissionStoreModelEnum.VIEW_BPP]"
          [routeSegments]="[RouteSegments.Root, RouteSegments.ImbalanceTrading]"
          iconKey="imbalance-trading-24"
          [label]="'side-menu.imbalance-trading' | translate"
          (navigationClick)="onNavigationClick($event)"
        />
      }

      @if (isLoggedIn() && !isMobile()) {
        <app-side-menu-nested-item
          [isSideMenuOpen]="isOpen() && isFullyOpened()"
          *appIfPermission="[
            PermissionStoreModelEnum.VIEW_BUSINESS_PROCESSES,
            PermissionStoreModelEnum.VIEW_ANY_ORGANISATIONS,
            PermissionStoreModelEnum.VIEW_BUSINESS_SETTINGS,
            PermissionStoreModelEnum.MANAGE_NOMINATION_CANCELLATION,
          ]"
          iconKey="profile-24"
          [label]="'side-menu.admin' | translate"
          [isMenuOpen]="isAdminMenuOpen()"
          [routes]="[
            {
              routeSegments: [RouteSegments.Root, RouteSegments.Admin, RouteSegments.BusinessProcesses],
              label: 'side-menu.admin-business-processes' | translate,
              permissions: [PermissionStoreModelEnum.VIEW_BUSINESS_PROCESSES],
            },
            {
              routeSegments: [RouteSegments.Root, RouteSegments.Admin, RouteSegments.NominationCancellation],
              label: 'side-menu.nomination-cancellation' | translate,
              permissions: [PermissionStoreModelEnum.MANAGE_NOMINATION_CANCELLATION],
            },
            {
              routeSegments: [RouteSegments.Root, RouteSegments.Admin, RouteSegments.Organisations],
              label: 'side-menu.admin-organisations' | translate,
              permissions: [PermissionStoreModelEnum.VIEW_ANY_ORGANISATIONS],
            },
            {
              routeSegments: [RouteSegments.Root, RouteSegments.Admin, RouteSegments.GlobalBusinessSettings],
              label: 'side-menu.admin-global-business-settings' | translate,
              permissions: [PermissionStoreModelEnum.VIEW_BUSINESS_SETTINGS, PermissionStoreModelEnum.MANAGE_BUSINESS_SETTINGS],
            },
            {
              routeSegments: [RouteSegments.Root, RouteSegments.Admin, RouteSegments.ExternalUsers],
              label: 'side-menu.admin-external-users' | translate,
              permissions: [PermissionStoreModelEnum.VIEW_EXTERNAL_USERS, PermissionStoreModelEnum.MANAGE_EXTERNAL_USERS],
            },
          ]"
          (navigationClick)="onNavigationClick($event)"
        />
      }

      @if (isLoggedIn() && !isMobile()) {
        <app-side-menu-item
          [isSideMenuOpen]="isOpen() && isFullyOpened()"
          *appIfPermission="[PermissionStoreModelEnum.VIEW_OWN_AUDIT_LOGS, PermissionStoreModelEnum.VIEW_ANY_AUDIT_LOGS]"
          [routeSegments]="[RouteSegments.Root, RouteSegments.AuditLogs]"
          iconKey="audit-24"
          [label]="'side-menu.audit-logs' | translate"
          (navigationClick)="onNavigationClick($event)"
        />
      }

      @if (isLoggedIn()) {
        @if (!isMobile()) {
          <app-side-menu-item
            [isSideMenuOpen]="isOpen() && isFullyOpened()"
            *appIfPermission="[
              PermissionStoreModelEnum.VIEW_OWN_USERS,
              PermissionStoreModelEnum.VIEW_OWN_ORGANISATIONS,
              PermissionStoreModelEnum.VIEW_OWN_DEFAULT_NOMINATIONS,
            ]"
            [routeSegments]="[RouteSegments.Root, RouteSegments.Organisation]"
            iconKey="settings-24"
            [label]="'side-menu.settings' | translate"
            (navigationClick)="onNavigationClick($event)"
          />
        } @else {
          <app-side-menu-item
            [isSideMenuOpen]="isOpen() && isFullyOpened()"
            *appIfPermission="[PermissionStoreModelEnum.VIEW_OWN_ORGANISATIONS]"
            [routeSegments]="[RouteSegments.Root, RouteSegments.Organisation, RouteSegments.OrganisationOverview]"
            iconKey="settings-24"
            [label]="'side-menu.settings-mobile' | translate"
            (navigationClick)="onNavigationClick($event)"
          />
        }
      }

      @if (isLoggedIn() && !isMobile()) {
        <app-side-menu-nested-item
          [isSideMenuOpen]="isOpen() && isFullyOpened()"
          *appIfPermission="[
            PermissionStoreModelEnum.VIEW_DATA_FLOWS,
            PermissionStoreModelEnum.MANAGE_ANY_MANUAL_FILE_UPLOAD,
            PermissionStoreModelEnum.MANAGE_OWN_MANUAL_FILE_UPLOAD,
          ]"
          iconKey="file-24"
          [label]="'side-menu.file-management' | translate"
          [isMenuOpen]="isFileManagementMenuOpen()"
          [routes]="[
            {
              routeSegments: [RouteSegments.Root, RouteSegments.DataFlow],
              label: 'side-menu.data-flow-overview' | translate,
              permissions: [PermissionStoreModelEnum.VIEW_DATA_FLOWS],
            },
            {
              routeSegments: [RouteSegments.Root, RouteSegments.NominationUpload],
              label: 'side-menu.nomination-upload' | translate,
              permissions: [PermissionStoreModelEnum.MANAGE_ANY_MANUAL_FILE_UPLOAD, PermissionStoreModelEnum.MANAGE_OWN_MANUAL_FILE_UPLOAD],
            },
          ]"
          (navigationClick)="onNavigationClick($event)"
        />
      }

      @if (isLoggedIn() && isMobile()) {
        <app-side-menu-item
          [isSideMenuOpen]="isOpen() && isFullyOpened()"
          *appIfPermission="[PermissionStoreModelEnum.VIEW_ANY_ORGANISATIONS]"
          [routeSegments]="[RouteSegments.Root, RouteSegments.Admin, RouteSegments.Organisations]"
          [label]="'side-menu.admin-organisations-mobile' | translate"
          (navigationClick)="onNavigationClick($event)"
        />
      }

      @if (isLoggedIn() && helpFaqUrl) {
        <ng-container *appIfPermission="[PermissionStoreModelEnum.VIEW_HELP_FAQ]">
          <a [href]="helpFaqUrl" target="_blank">
            <app-side-menu-item
              [isSideMenuOpen]="isOpen() && isFullyOpened()"
              iconKey="help-desk-24"
              [label]="'side-menu.help-faq' | translate"
              (navigationClick)="onNavigationClick($event)"
            />
          </a>
        </ng-container>
      }
    </div>
  </div>
</nav>
